import 'swiper/css';

window.TestimonialSlider = () => {
	return {
		swiper: null,
		init() {
			this.swiper = new Swiper(this.$refs.swiper, {
				modules: [SwiperModules.Navigation, SwiperModules.Pagination],

				loop: true,
				slidesPerView: 1,
				spaceBetween: 40,
				observer: true,
				observeParents: true,

				breakpoints: {
					768: {
						slidesPerView: 2
					},
					1024: {
						slidesPerView: 1
					}
				},

				pagination: {
					el: this.$refs.pagination,
					clickable: true,
				},

				navigation: {
					nextEl: this.$refs.next,
					prevEl: this.$refs.prev,
				},
				
				a11y: true,
			});
		},
	};
};
